
import { useEffect, useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
//--------------------------------------------------------------------------------------------
export default function CommunityForm({
    keyword,
    handleSubmit,
    closeIt,
   
    photos,

    communityHashKey,
    picArrayId,
    subject, 
    body
}){
    const [curPhotos, setCurPhotos] = useState(photos);
    useEffect(() => {
        if(keyword ===  "Add"){
            setCurPhotos([]);
        }
    }, [setCurPhotos, keyword])
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"900px"}
            maxWidth = {"100%"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <div>
                <input
                    className = "nodisplay" readOnly
                    name = "communityHashKey" value = {communityHashKey || ""}
                />
                <input
                    className = "nodisplay" readOnly
                    name = "picArrayId" value = {picArrayId || ""}
                />
                <div className = "my-2" style = {{display:"flex"}}>
                    <span className = "font-weight-bold mr-3">Subject:</span>
                    <input
                        type = "text"
                        required
                        className = "form-control"
                        style = {{flexGrow: 1}}
                        name = "subject"
                        defaultValue = {subject || ""}
                    />
                </div>
                <div className = "my-2" style = {{display:"flex"}}>
                    <span className = "font-weight-bold mr-3">Body:</span>
                    <textarea required className = "form-control" style = {{flexGrow: 1}} name = "body" defaultValue = {body || ""}/>
                </div>
                <div className = "my-3">
                    <span className = "btn btn-primary" onClick = {e => {e.currentTarget.nextElementSibling.click()}}>Upload New Photos</span>
                    <input
                        className = "nodisplay"
                        type = "file"
                        accept = "image/png, image/jpeg"
                        multiple
                        onChange = {async e => {
                            const target = e.currentTarget;
                            const files = target.files;
                            const fileListToBase64 = async fileList => {
                                // create function which return resolved promise
                                // with data:base64 string
                                const getBase64 = file => {
                                    const reader = new FileReader();
                                    return new Promise(resolve => {
                                        reader.onload = ev => {
                                            resolve(ev.target.result);
                                        }
                                        reader.readAsDataURL(file);
                                    });
                                }
                                // here will be array of promisified functions
                                const promises = []
                                // loop through fileList with for loop
                                for(let i = 0; i < fileList.length; i++){
                                    promises.push(getBase64(fileList[i]))
                                }
                                // array with base64 strings
                                return await Promise.all(promises)
                            }
                            if(files.length > 10){
                                window.alert("max 10 pictures");
                                return;
                            }
                            const arrayOfBase64 = await fileListToBase64(files)
                            setCurPhotos([...curPhotos, ...arrayOfBase64]);
                            target.value = "";
                        }}
                    />
                    <input
                        className = "nodisplay" readOnly
                        name = "photos" value = {JSON.stringify(curPhotos)}
                    />
                    <div>
                        {curPhotos.map((photo, i) => <span style = {{position: "relative"}}><img key = {i} width = {100} height = {100} className = "m-3" src = {photo} alt = ""/><span  style = {{position: "absolute", left: 100, top: -50, color: "white", fontWeight: 650, background: "red", borderRadius: "59%", lineHeight: 1, margin: 0, padding: "3px 0px", cursor: "pointer", fontSize: 27}} onClick = {() => {
                            setCurPhotos([...curPhotos.slice(0, i), ...curPhotos.slice(i + 1)]);
                        }}>&nbsp;✕&nbsp;</span></span>)}
                    </div>
                </div>
            </div>
        </Modal>
    )
}